import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const detailInnerSectionHeadingDefaultVariants = {}
const detailInnerSectionHeadingCompoundVariants = []

const detailInnerSectionHeadingSlotNames = [
  [
    "root",
    "detail-inner-section-heading__root"
  ],
  [
    "title",
    "detail-inner-section-heading__title"
  ],
  [
    "subtitle",
    "detail-inner-section-heading__subtitle"
  ],
  [
    "intro",
    "detail-inner-section-heading__intro"
  ],
  [
    "update",
    "detail-inner-section-heading__update"
  ]
]
const detailInnerSectionHeadingSlotFns = /* @__PURE__ */ detailInnerSectionHeadingSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, detailInnerSectionHeadingDefaultVariants, getSlotCompoundVariant(detailInnerSectionHeadingCompoundVariants, slotName))])

const detailInnerSectionHeadingFn = memo((props = {}) => {
  return Object.fromEntries(detailInnerSectionHeadingSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const detailInnerSectionHeadingVariantKeys = []
const getVariantProps = (variants) => ({ ...detailInnerSectionHeadingDefaultVariants, ...compact(variants) })

export const detailInnerSectionHeading = /* @__PURE__ */ Object.assign(detailInnerSectionHeadingFn, {
  __recipe__: false,
  __name__: 'detailInnerSectionHeading',
  raw: (props) => props,
  variantKeys: detailInnerSectionHeadingVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, detailInnerSectionHeadingVariantKeys)
  },
  getVariantProps
})